
import { mapGetters } from 'vuex'
import register from '~/mixins/pages/register/register'
import registerSEO from '~/mixins/common/pages/register'
import checkApp from '~/mixins/pages/register/checkApp'
export default {
    name: 'Theme3DesktopRegisterForm',
    mixins: [register, registerSEO, checkApp],
    middleware: 'auth',
    data() {
        return {
            isConditional: false,
            rememberMe: false,
        }
    },
    computed: {
        ...mapGetters({
            getRegistrationSuspendByCurrency:
                'settings/getRegistrationSuspendByCurrency',
        }),
    },
    watch: {
        acceptCondition(value) {
            if (value) {
                this.isConditional = false
            } else {
                this.isConditional = true
            }
        },
    },
    mounted() {
        if (
            this.getRegistrationSuspendByCurrency(
                this.$cookie.get('currency')
            ) === true
        ) {
            this.$router.push('/')
        }
    },
    methods: {
        register() {
            if (this.acceptCondition) {
                if (this.$refs.form.validate()) {
                    this.onUserRegister()
                }
            } else {
                this.isConditional = true
                this.$toast.error(this.tl('pleaseCheckCheckCondition'))
            }
        },
    },
}
